import { StatusId, OperationMS } from '../types';

// Statut affiche acheteur-MS : couleur + expiration calculees PAR ID (pas par nom).
// Memes couleurs que l'ancien getStatusColor de SuiviOperation, mais cle = id de statut
// -> insensible aux renommages DB. Le libelle affiche reste le nom (purement presentationnel).

const GRIS = '#6B7280';
const ORANGE = '#F4751B';
const ROUGE = '#D90E0E';
const VERT = '#00A708';

// Derive verbatim de l'ancienne map par nom (Valider=vert, A analyser/A signer=orange,
// Refuser/Expirer/Annule=rouge, le reste gris) mais indexe par id.
const COLOR_BY_ID: Record<number, string> = {
  [StatusId.Brouillon]: GRIS,
  [StatusId.ConsultationEnCours]: GRIS,
  [StatusId.ACandidater]: GRIS,
  [StatusId.AAnalyser]: ORANGE,
  [StatusId.EnAttenteAnalyse]: GRIS,
  [StatusId.Refuser]: ROUGE,
  [StatusId.ASigner]: ORANGE,
  [StatusId.EnAttenteSignaturePrestataire]: GRIS,
  [StatusId.EnAttenteSignatureAcheteur]: GRIS,
  [StatusId.ASignerPrestataire]: ORANGE,
  [StatusId.Valider]: VERT,
  [StatusId.Expirer]: ROUGE,
  [StatusId.ANotifier]: ORANGE, // process actuel : 13 = "A signer" (action acheteur)
  [StatusId.Annule]: ROUGE,
};

export const statusColorById = (statusId?: number): string =>
  (statusId !== undefined ? COLOR_BY_ID[statusId] : undefined) || GRIS;

// Annulation possible tant que non signe (Valider=11) ni deja annule (Annule=14).
// Predicat de statut general (consomme par Consultation, Analyse et Marché).
export const canAnnulerOperation = (idStatus?: number): boolean =>
  idStatus !== StatusId.Valider && idStatus !== StatusId.Annule;

const isDateExpired = (dateStr?: string): boolean => {
  if (!dateStr) return false;
  const target = new Date(dateStr).getTime();
  return !Number.isNaN(target) && Date.now() >= target;
};

export interface OperationStatusView {
  label: string;
  color: string;
  isExpired: boolean;
}

// Expiration reelle = statut Expirer(12), point.
// Le chrono / la date expire_at ne valent QUE pendant la consultation (statut 2) :
// c'est le delai de remise des offres. Des que l'operation passe en analyse (4) ou
// au-dela, un expire_at depasse (ou un event chrono) est residuel — historiquement
// des chronos ont ete poses a tort sur des operations MS — et ne doit PAS marquer
// l'operation expiree : le statut continue de piloter l'affichage et les actions.
export const isOperationExpired = (operation: OperationMS, chronoExpired = false): boolean => {
  if (operation.status?.id === StatusId.Expirer) return true;
  if (operation.status?.id !== StatusId.ConsultationEnCours) return false;
  return chronoExpired || isDateExpired(operation.expire_at);
};

export const computeOperationStatus = (
  operation: OperationMS,
  chronoExpired = false,
): OperationStatusView => {
  const expired = isOperationExpired(operation, chronoExpired);
  return {
    label: operation.status?.nom || 'Statut inconnu', // texte affiche (presentationnel)
    color: expired ? ROUGE : statusColorById(operation.status?.id),
    isExpired: expired,
  };
};
